import { STORAGE_KEYS } from '@/constants';
import { PERMISSION } from '@/constants/common/workflow';
import {HttpService, ResponseDTO} from '@/shared';
import { PermissionsPartnerDTO } from '@/shared/dto/partner.dto';
import {action, observable} from 'mobx';
import Container, {Service} from 'typedi';
@Service()
export class PartnerService {
  @observable
  private readonly httpService = Container.get(HttpService);

  @observable
  private permissionUpdateListeners: Array<() => void> = [];

  @action.bound
  public addPermissionUpdateListener(callback: () => void): void {
    const index = this.permissionUpdateListeners.indexOf(callback);
    if (index == -1) {
      this.permissionUpdateListeners.push(callback);
    }
  }

  @action.bound
  public removePermissionUpdateListener(callback: () => void): void {
    const index = this.permissionUpdateListeners.indexOf(callback);
    if (index !== -1) {
      this.permissionUpdateListeners.splice(index, 1);
    }
  }

  @action.bound
  public async getPermissionsPartner(
    permissionDTO: PermissionsPartnerDTO,
  ): Promise<ResponseDTO<PERMISSION[]>> {
    const response = await this.httpService.request(permissionDTO);

    const permissions = response.data;
    if (permissions) {
      localStorage.setItem(STORAGE_KEYS.PARTNER_PERMISSIONS, JSON.stringify(permissions));
    } else {
      localStorage.setItem(STORAGE_KEYS.PARTNER_PERMISSIONS, JSON.stringify([]));
    }

    this.permissionUpdateListeners.forEach(callback => {
      try {
        callback();
      } catch (error) {
        console.error('Error in permission update listener:', error);
      }
    });

    return response;
  }

  public isSupportWorkflows(): boolean {
    try {
      const permissionsStr = localStorage.getItem(STORAGE_KEYS.PARTNER_PERMISSIONS);
      if (permissionsStr) {
        const permissions: PERMISSION[] = JSON.parse(permissionsStr);
        return permissions.includes(PERMISSION.workflows);
      }
      return false;
    } catch (error) {
      console.error('Failed to parse partner permissions:', error);
      return false;
    }
  }

  public isSupportMetadata(): boolean {
    return true;
  }

  public isSupportMBAL(): boolean {
    try {
      const permissionsStr = localStorage.getItem(STORAGE_KEYS.PARTNER_PERMISSIONS);
      if (permissionsStr) {
        const permissions: PERMISSION[] = JSON.parse(permissionsStr);
        return permissions.includes(PERMISSION.mbal);
      }
      return false;
    } catch (error) {
      console.error('Failed to parse partner permissions:', error);
      return false;
    }
  }

  public isSupportExportWorkflows(): boolean {
    try {
      const permissionsStr = localStorage.getItem(STORAGE_KEYS.PARTNER_PERMISSIONS);
      if (permissionsStr) {
        const permissions: PERMISSION[] = JSON.parse(permissionsStr);
        return permissions.includes(PERMISSION.export_workflow);
      }
      return false;
    } catch (error) {
      console.error('Failed to parse partner permissions:', error);
      return false;
    }
  }
}
